module.exports = __webpack_public_path__ + "ed294b221e32c83d9e79195d599313d3.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./~/octicons/octicons/octicons.ttf
 ** module id = 394
 ** module chunks = 0
 **/